export enum ECerfa {
  fsp = '11390*04',
  accordPrealable = '12010*04'
}
